import { createAction, props } from '@ngrx/store';

import { TransactionsListState } from '../reducers';

export const LoadTransactionsList = createAction(
  '[Transactions] Load Transactions List',
  props<{ transactionsListData: TransactionsListState, page: number }>()
);
